import React, { useContext, useEffect, useState } from 'react'
import Autocomplete from "react-autocomplete";
import './../Global/AutoComplete.css';
import useDebounce from './useDebounce';
import * as productContactStockCrud from '../../_crud/productContactStockCrud'

export function ProductContactStockSelector(props) {
    const { searchtext, setSelectedData, ids } = props
    const [isLocalLoading, setIsLocalLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState(searchtext);
    const [searchDebounce, setSearchDebounce] = useDebounce(searchtext, 500);
    const [data, setData] = useState([]);

    useEffect(() => {
        setSearchDebounce(searchTerm)
    }, [searchTerm]);

    useEffect(() => {
        getData()
    }, [searchDebounce]);
    useEffect(() => {
        getData()
    }, [ids]);
    function getData() {
        setIsLocalLoading(true);
        let a;
        a = searchTerm;
        if (!searchTerm) { a = '' }
        productContactStockCrud.GetByContactSelector({ Search: { searchTerm: a, pageNo: 1, pageSize: 10 }, ContactId: ids.contactId, productionUnitId: ids.productionUnitId })
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        setData(hdata);
                        setIsLocalLoading(false)
                    }
                    else {
                        setIsLocalLoading(false)
                        setData([]);
                    }
                }
                else {
                    setIsLocalLoading(false)
                    setData([]);
                }
            })
            .catch(error => {
                setData([]);
                setIsLocalLoading(false);
            })
    }

    function selectId(e) {
        setSearchTerm(e.split('|')[0])
        let sid = e.split('|')[1]

        data.forEach(d => {
            if (d.product.id == sid) {
                setSelectedData(d);
            }
        });
    }
    return (
        <span class="input-icon" style={{ width: "100%" }}>
            <div className="autocomplete-wrapper">
                <Autocomplete
                    inputProps={{ placeholder: "Type to search product" }}
                    value={searchTerm}
                    items={data}
                    getItemValue={item => item.product.productName + "|" + item.product.id}
                    renderMenu={item => (
                        <div className="dropdown">
                            {item}
                        </div>
                    )}
                    renderItem={(item, isHighlighted) =>
                        <div class={isHighlighted ? "profile-activity clearfix MyItem-selected-item" : "profile-activity clearfix"} style={{ cursor: "pointer" }}>
                            <div>
                                <i class="pull-left thumbicon fa fa-cube btn-info no-hover"></i>
                                <a class="user">{item.product.productName}</a> ({item.product.id})
                                <br /><span>{item.product.productCategory.catName}</span>
                            </div>
                        </div>
                    }
                    onChange={(event, val) => setSearchTerm(val)}
                    onSelect={val => selectId(val)}
                />
            </div>
            {isLocalLoading ?
                <i class="ace-icon fa fa-spinner fa-spin blue"></i>
                :
                <i class="ace-icon fa fa-cubes blue"></i>
            }
        </span>
    )
}

